if (!customElements.get("m-contador-regressivo")) {
  class ContadorRegressivoElement extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.startCountdown();
    }
    startCountdown() {
      const minutos = parseInt(this.dataset.time, 10);
      if (isNaN(minutos)) {
        console.error("Invalid minutos value:", this.dataset.time);
        return;
      }
      const endTime = new Date(Date.now() + minutos * 60000);
      this.updateCountdown(endTime);
    }
    updateCountdown(endTime) {
      const update = () => {
        const now = new Date();
        const timeLeft = endTime - now;
        if (timeLeft <= 0) {
          this.updateDisplay(0, 0);
          clearInterval(this.interval);

          // Reinicia o contador após 1 segundo
          setTimeout(() => this.startCountdown(), 1000);
          return;
        }
        const minutos = Math.floor(timeLeft / 60000);
        const segundos = Math.floor((timeLeft % 60000) / 1000);
        this.updateDisplay(minutos, segundos);
      };

      update();
      this.interval = setInterval(update, 1000);
    }
    updateDisplay(minutos, segundos) {
      const minutesElement = this.querySelector(".contador-minutos");
      const secondsElement = this.querySelector(".contador-segundos");

      if (minutesElement && secondsElement) {
        minutesElement.textContent = String(minutos).padStart(2, "0");
        secondsElement.textContent = String(segundos).padStart(2, "0");
      } else {
        console.error("Contador regressivo não encontrado.");
      }
    }
  }
  customElements.define("m-contador-regressivo", ContadorRegressivoElement);
}